// extracted by mini-css-extract-plugin
module.exports = {"root":"Badges_root__5T7Vt","timeIcon":"Badges_timeIcon__lVX3Z","datetime":"Badges_datetime__jCV7E"};